import React from 'react';
import { tryGetAppContext } from '~/lib/AppContext';
import { EventEmitter } from '~/lib/helper/EventHelper';
import LiveRegion from './LiveRegion';

/** The announcer of the nearest enclosing dialog; undefined outside one. */
export const DialogAnnouncerContext = React.createContext<EventEmitter<string> | undefined>(undefined);

/** A polite live region scoped to a dialog, provided to its children through `DialogAnnouncerContext`; `DialogModal` renders one. */
export class DialogLiveRegion extends React.Component<{ children?: React.ReactNode }> {
    private readonly emitter = new EventEmitter<string>();

    render() {
        return (
            <DialogAnnouncerContext.Provider value={this.emitter}>
                {this.props.children}
                {/* Last, so reading the dialog on focus doesn't repeat a just-announced message before its content. */}
                <LiveRegion source={this.emitter} />
            </DialogAnnouncerContext.Provider>
        );
    }
}

/** Announces politely through the dialog's region when `dialog` is set, else the layout `announce` bus. */
export function announce(dialog: EventEmitter<string> | undefined, message: string) {
    (dialog ?? tryGetAppContext()?.announce)?.fire(message);
}
